import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicSiteShell from "../../components/public/PublicSiteShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const MnuSupport = () => {
  const navigate = useNavigate();

  const hero = (
    <section className="public-info-hero">
      <CContainer fluid className="public-core-container public-page-shell public-info-shell">
        <div className="public-info-hero__panel public-page-hero-panel">
          <div className="public-info-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Support</span>
            <h1 className="public-page-title">Support, der Orientierung und Ruhe gibt</h1>
            <p className="public-page-body public-info-hero__lead">
              Experts4Europe soll nicht verwirren, sondern verständlich begleiten. Deshalb sind
              die wichtigsten öffentlichen Einstiege, Hinweise und nächsten Schritte klar strukturiert.
            </p>
            <div className="public-legal-chip-row">
              <span>Orientierung</span>
              <span>Klare Sprache</span>
              <span>Nächster Schritt</span>
            </div>
          </div>
          <aside className="public-info-hero__meta">
            <div className="public-page-callout public-info-callout">
              <strong>Worum es hier geht</strong>
              <span>Öffentliche Unterstützung bleibt sachlich, verständlich und direkt an den nächsten sinnvollen Schritten ausgerichtet.</span>
            </div>
            <div className="public-page-callout public-info-callout">
              <strong>Was bewusst vermieden wird</strong>
              <span>Keine technische Innenansicht, keine Admin-Sprache und keine unruhige Boxenwelt auf öffentlichen Seiten.</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicSiteShell pageClassName="public-info-page" hero={hero}>
      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-page-shell public-info-shell">
          <div className="public-info-stack">
            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Wobei wir helfen</span>
              <div className="public-info-list">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Profil und Bewerbung</h2>
                  <p className="public-page-body">Verstehe, was schon tragfähig ist und wo noch sichtbare Lücken oder nächste Schritte liegen.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Sprache und Vorbereitung</h2>
                  <p className="public-page-body">Arbeite fokussiert an Sprache, Readiness und Unterlagen statt an unverbundenen Einzelthemen.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Chancen und Sicherheit</h2>
                  <p className="public-page-body">Sieh passende Jobs, geschützte Zugänge und klare nächste Schritte ohne technische Überladung.</p>
                </div>
              </div>
            </article>

            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Wie Support gedacht ist</span>
              <div className="public-info-list public-info-list--compact">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Klare Sprache</h2>
                  <p className="public-page-body">Öffentliche Hinweise sollen verständlich sein und keine Produktinnensprache voraussetzen.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Direkte Wege</h2>
                  <p className="public-page-body">Die Plattform zeigt, wo ein sinnvoller nächster Schritt liegt, statt in Unterseiten zu zerfasern.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Eine Public-Familie</h2>
                  <p className="public-page-body">Support, Leitbild, Legal-Seiten und weitere öffentliche Einstiege bleiben sichtbar aus derselben Produktfamilie.</p>
                </div>
              </div>
            </article>

            <div className="public-info-actions public-page-card">
              <div className="public-info-actions__copy">
                <span className="public-core-eyebrow public-page-overline">Direkt weiter</span>
                <h2 className="public-page-subtitle">Zum passenden öffentlichen Einstieg</h2>
              </div>
              <div className="public-info-actions__buttons">
                <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/login")}>
                  Anmelden
                </CButton>
                <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/applicant/frontdoor?entry=abroad")}>
                  Quick Check
                </CButton>
              </div>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicSiteShell>
  );
};

export default MnuSupport;
